module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Necchi_Ind.Blue_Orange_White.886752ed.png";